import { render } from "./Projections.vue?vue&type=template&id=8f9dca30&scoped=true"
import script from "./Projections.vue?vue&type=script&lang=js"
export * from "./Projections.vue?vue&type=script&lang=js"

import "./Projections.vue?vue&type=style&index=0&id=8f9dca30&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f9dca30"]])

export default __exports__